module.exports = __webpack_public_path__ + "static/media/attach_file.299647f1.png";